<template>
  <div class="app-inner">
    <div class="searchTitleDiv">
      <div class="stateDiv">
        <p class="searchText">公示标题</p>
        <el-input v-model="searchFrom.title" placeholder="请输入" clearable class="inputDiv"></el-input>
      </div>
      <!-- <div class="stateDiv">
        <p class="searchText">状态</p>
        <el-select v-model="searchFrom.status" placeholder="请选择" class="inputDiv" clearable>
          <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </div> -->
      <el-button class="searchBtn" type="primary" @click="getData">查 询</el-button>
      <el-button class="searchBtn" type="warning" @click="addFormData"  v-if="roleName === '办公室'">新增公告</el-button>
    </div>
    <!--      列表-->
    <div class="table">
      <div class="searchList">
        <TableList :data="tableData" :columnDefs="tableColumns" :total="totalCount" @pageChange="handleCurrentChange">
          <template #action="{ row, index }" class="tableButton">
            <el-button class="tableBtn" @click="viewOrHandle(row, 'edit')" type="text" size="small" v-if="roleName === '办公室'">编辑
            </el-button>
            <el-button class="tableBtn" @click="viewOrHandle(row, 'view')" type="text" size="small">查看详情
            </el-button>
            <el-button class="tableBtn" @click="deleteFun(row)" type="text" size="small"  v-if="roleName === '办公室'">删除</el-button>
          </template>
        </TableList>
      </div>
    </div>
    <!--    新增/编辑弹框-->
    <div class="dialogDiv">
      <el-dialog :title="eventControl" :visible.sync="dialogFormVisible" :before-close="closeData" center>
        <el-form ref="addForm" :model="addForm" :rules="rules" label-width="100px" :disabled="eventControl === '查看详情'">
          <el-row>
            <el-form-item label="标题" prop="title" class="formItem">
              <el-input v-model="addForm.title" clearable placeholder="请输入"></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="内容" prop="content" class="formItem">
              <el-input type="textarea" rows="5" v-model="addForm.content" clearable placeholder="请输入" maxlength="500" show-word-limit></el-input>
            </el-form-item>
          </el-row>
          <el-row>
            <el-form-item label="附件上传" prop="" class="formItem">
              <uploadPreviewFile v-model="addForm.fileUrlList" :type="type"/>
              <!-- <uploadFile @handleFile="handleFile" :attachmentUrlList="addForm.fileUrlList"></uploadFile> -->
            </el-form-item>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeData">取 消</el-button>
          <el-button type="primary" @click="addEventForm()" v-if="eventControl !== '查看详情'">保 存</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { noticeInfo } from '@/api/basicInfo'
import { Message } from 'element-ui'
import TableList from '@/components/TableList'
// import uploadFile from '@/components/upload/uploadFile'
import uploadPreviewFile from '@/components/upload/uploadPreviewFile'
import base from '@/utils/index'
export default {
  name: 'accountPage',
  components: {
    TableList,
    uploadPreviewFile
    // uploadFile
  },
  data() {
    return {
      loading: false,
      type: 'new',
      roleName: '',
      searchFrom: {
        title: '',
        status: ''
      },
      currentPage: 1,
      totalCount: 0,
      pageSize: 10,
      dialogFormVisible: false,
      eventControl: '',
      edit: false,
      passwordForm: {},
      addForm: {
        title: '', // 标题
        content: '', // 内容
        fileUrlList: '', // 园区属性
      },
      rules: {
        title: [{ required: true, message: '请填写', trigger: 'blur' }],
        content: [{ required: true, message: '请填写', trigger: 'blur' }],
      },
      tableData: [],
      statusOptions: [
        {
          label: '未查看',
          value: 0
        },
        {
          label: '已查看',
          value: 1
        },
      ],
      tableColumns: [
        {
          prop: 'title',
          label: '公示标题'
        },
        {
          prop: 'createTime',
          label: '公示时间'
        },
        // {
        //   prop: 'status',
        //   label: '状态',
        //   formatter: (row, column, v) => {
        //     return row.status === 1 ? '已查看' : '未查看'
        //   }
        // },
        {
          prop: 'action',
          label: '操作',
        },
      ]
    }
  },
  mounted() {
    this.getData()
    const baseFunc = base()
    this.roleName = baseFunc.getLocalStorage('userInfo_roleName')
  },
  methods: {
    handleFile(imgs) {
      let arrFile = imgs.map(v => v.code).join(',')
      this.addForm.fileUrlList = arrFile
    },
    getData() {
      this.currentPage = 1
      this.queryList()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.queryList()
    },
    async queryList() {
      let res = await noticeInfo('query', {
        title: this.searchFrom.title,
        content: this.searchFrom.content,
        pageNum: this.currentPage,
        pageSize: this.pageSize
      })
      if (res.code === 0) {
        this.tableData = res.result.records
        this.totalCount = res.result.total
      }
    },
    addFormData() {
      this.edit = false
      this.dialogFormVisible = true
      this.type = 'new'
      this.eventControl = '新增公告'
    },
    async viewOrHandle(row, type) {
      this.edit = true
      this.type = type === 'edit' ? 'new' : 'view'
      this.eventControl = type === 'edit' ? '编辑公告' : '查看详情'
      this.newOldFormContrast(row)
      this.dialogFormVisible = true
    },
    newOldFormContrast(newForm) {
      Object.keys(this.addForm).forEach(key => {
        this.addForm[key] = newForm[key]
      })
      this.addForm.id = newForm.id
    },
    closeData() {
      this.dialogFormVisible = false
      this.$refs['addForm'].resetFields()
      this.addForm = this.$options.data.call(this).addForm
    },
    addEventForm() {
      this.$refs['addForm'].validate(async (valid) => {
        if (valid) {
          if (this.edit) {
            let res = await noticeInfo('update', this.addForm)
            if (res.code === 0) {
              Message.success('编辑成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.warning({ message: res.message })
            }
          } else {
            let res = await noticeInfo('add', this.addForm)
            if (res.code === 0) {
              Message.success('新增成功！')
              this.closeData()
              await this.getData()
            } else {
              Message.error(res.message)
            }
          }
        }
      })
    },
    // 删除用户
    deleteFun(row) {
      this.$confirm('此操作将删除公示, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        let params = {
          'id': row.id
        }
        let res = await noticeInfo('deleteById', params)
        if (res.code === 0) {
          Message.success('删除成功！')
        }
        await this.getData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.app-inner {
  width: 98%;
  height: 70vh;
  padding: 0.2rem;
  box-sizing: border-box;
}

.searchTitleDiv {
  width: 15rem;
  height: 0.66rem;
  margin-left: 0.2rem;
  margin-top: 0.05rem;
  /*display: flex;*/
  /*justify-content: space-around;*/

  .stateDiv {
    margin-top: 0.14rem;
    margin-left: .3rem;
    float: left;
  }

  .searchText {
    margin-top: 0.05rem;
    margin-right: 0.13rem;
    font-size: 0.2rem;
    color: #111111;
    float: left;
  }

  .inputDiv {
    width: 2.2rem;
    float: left;
  }

  .searchBtn {
    /*width: 1.20rem;*/
    /*height: 0.36rem;*/
    /*border-radius: 0.06rem;*/
    /*font-size: 0.18rem;*/
    margin-top: 0.14rem;
    margin-left: .3rem;
    /*padding-top: 0.1rem;*/
  }
}

.table {
  margin-top: .3rem;
  margin-left: .5rem;
  text-align: center;
  width: 14.8rem;

  .searchList {}

  .paginationBody {
    margin-top: .1rem;
  }
}

.formItem {
  // width: 3.2rem;
}

/deep/ .el-dialog {
  width: 45% !important;
}
</style>
